export default {"src":"/_next/static/media/scroll.5dd66a68.svg","height":386,"width":822,"blurWidth":0,"blurHeight":0};